import { ITariffAgreements } from "./tariffAgreements.types"
import { ITariff } from "../tariff/tariff.types"
import { Tariff } from "../tariff/tariff"
import tariffHelper from "@/helpers/tariffHelper"
import { IAgreement } from "@/models/agreement/agreement.types"

export class TariffAgreements implements ITariffAgreements {
  id: number
  activeAgreement?: IAgreement
  currentTariff?: ITariff
  publiclyAvailableTariffList?: ITariff[]
  smartPaygTariffs?: ITariff[]

  constructor({
    id,
    activeAgreement,
    currentTariff,
    publiclyAvailableTariffList,
    smartPaygTariffs,
  }: {
    id: number
    activeAgreement?: IAgreement
    currentTariff?: ITariff
    publiclyAvailableTariffList?: ITariff[]
    smartPaygTariffs?: ITariff[]
  }) {
    this.id = id
    this.activeAgreement = activeAgreement
    this.currentTariff = currentTariff ? new Tariff(currentTariff) : undefined
    this.publiclyAvailableTariffList = publiclyAvailableTariffList?.map(
      (tariff) => new Tariff(tariff),
    )
    this.smartPaygTariffs = smartPaygTariffs?.map(
      (tariff) => new Tariff(tariff),
    )
  }

  get isGas(): boolean {
    if (!this.currentTariff) return false
    return tariffHelper.isGas(this.currentTariff.code)
  }
}
